import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../components/Header';
import RenderTiptap from '../components/Editor/RenderTiptap';
import { paraExibicao } from '../components/Editor/tiptapBase';
import { useAuth } from '../contexts/AuthContext';
import api from '../api';
import { formatarData, estaAtrasado } from '../utils/datas';

const STATUS = {
  aberto: { l: 'Aberta', c: 'alerta' },
  em_andamento: { l: 'Em andamento', c: 'neutro' },
  concluido: { l: 'Concluída', c: 'ok' },
  cancelado: { l: 'Cancelada', c: 'neutro' },
};
const fmt = (d) => formatarData(d);
const parse = (c) => { if (!c) return null; if (typeof c === 'object') return c; try { return JSON.parse(c); } catch (_) { return null; } };

export default function AtaView() {
  const { id } = useParams();
  const { token } = useAuth();
  const [dados, setDados] = useState(null);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(true);

  function carregar() {
    return api.get(`/atas/${id}`)
      .then(({ data }) => setDados(data))
      .catch(err => setErro(err.response?.data?.error || 'Erro ao carregar a ata'))
      .finally(() => setCarregando(false));
  }
  useEffect(() => { carregar(); }, [id]);

  async function mudarStatus(t, status) {
    let observacao;
    if (status === 'concluido') {
      const r = await Swal.fire({
        icon: 'question', title: 'Marcar como feita?', text: t.descricao,
        input: 'textarea', inputPlaceholder: 'Quer deixar alguma observação? (opcional)',
        showCancelButton: true, confirmButtonText: 'Sim, está feita', cancelButtonText: 'Cancelar',
      });
      if (!r.isConfirmed) return;
      observacao = r.value || null;
    }
    try {
      await api.put(`/atas/pendencias/${t.id}/status`, { status, ...(observacao !== undefined ? { observacao } : {}) });
      carregar();
    } catch (err) {
      Swal.fire('Ops', err.response?.data?.error || 'Não foi possível atualizar a tarefa.', 'error');
    }
  }

  const a = dados?.ata;
  const conteudo = a ? paraExibicao(parse(a.conteudo), token) : null;

  return (
    <>
      <Header />
      <main className="conteudo-container" style={{ maxWidth: 860 }}>
        <Link to={a?.pasta_id ? `/atas?pasta=${a.pasta_id}` : '/atas'} className="doc-voltar">
          <i className="bi bi-arrow-left"></i> {a?.pasta_nome || 'Atas'}
        </Link>
        {carregando && <div>Carregando…</div>}
        {erro && <div className="erro">{erro}</div>}

        {a && (
          <>
            <div className="conteudo-card">
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
                <div>
                  <h1 style={{ color: 'var(--verde)', fontWeight: 700, margin: '0 0 4px' }}>{a.titulo}</h1>
                  <div className="adm-sub">
                    {fmt(a.data_reuniao)}
                    {a.proxima_reuniao && ` · próxima em ${fmt(a.proxima_reuniao)}`}
                  </div>
                </div>
                {dados.pode_gerir && (
                  <Link to={`/atas/${a.id}/editar`} className="btn-centrao-laranja" title="Editar"><i className="bi bi-pencil"></i></Link>
                )}
              </div>
              {conteudo && <div style={{ marginTop: 14 }}><RenderTiptap conteudo={conteudo} /></div>}
            </div>

            <h2 className="trilha-secao">Tarefas da reunião</h2>
            <div className="adm-tabela-wrap">
              <table className="adm-tabela">
                <thead><tr><th>O que ficou combinado</th><th>Responsável</th><th>Prazo</th><th>Situação</th><th></th></tr></thead>
                <tbody>
                  {dados.tarefas.map(t => {
                    const st = STATUS[t.status] || STATUS.aberto;
                    const minha = t.responsavel_id === dados.meu_id;
                    const aberta = t.status === 'aberto' || t.status === 'em_andamento';
                    const atrasada = aberta && estaAtrasado(t.prazo);
                    return (
                      <tr key={t.id} className={atrasada ? 'adm-linha-alerta' : ''}>
                        <td>
                          {t.descricao}
                          {t.observacao && <div className="adm-sub">obs: {t.observacao}</div>}
                        </td>
                        <td>{t.responsavel_nome || <span className="adm-sub">sem responsável</span>}</td>
                        <td style={{ whiteSpace: 'nowrap' }}>
                          {fmt(t.prazo) || <span className="adm-sub">—</span>}
                          {atrasada && <div className="adm-sub" style={{ color: '#C62828' }}>atrasada</div>}
                        </td>
                        <td><span className={`adm-badge adm-badge--${st.c}`}>{st.l}</span></td>
                        <td>
                          {aberta && (minha || dados.pode_gerir) && (
                            <div className="adm-acoes">
                              {t.status === 'aberto' && (
                                <button className="adm-btn-icone" title="Comecei" onClick={() => mudarStatus(t, 'em_andamento')}>
                                  <i className="bi bi-play"></i>
                                </button>
                              )}
                              <button className="adm-btn-icone" title="Marcar como feita" onClick={() => mudarStatus(t, 'concluido')}>
                                <i className="bi bi-check2"></i>
                              </button>
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {dados.tarefas.length === 0 && <tr><td colSpan={5} className="adm-vazio">Nenhuma tarefa saiu dessa reunião.</td></tr>}
                </tbody>
              </table>
            </div>
          </>
        )}
      </main>
    </>
  );
}
